import { StyleSheet } from "react-native";

export type SeekBarVariant = "compact" | "full";

export type SeekBarProps = {
	position: number;
	duration: number;
	onSeek: (position: number) => void;
	variant: SeekBarVariant;
};

type SeekBarMetrics = {
	containerHeight: number;
	trackHeight: number;
	handleWidth: number;
	handleHeight: number;
	handleGap: number;
};

export const SEEK_BAR_METRICS: Record<SeekBarVariant, SeekBarMetrics> = {
	compact: {
		containerHeight: 24,
		trackHeight: 6,
		handleWidth: 4,
		handleHeight: 16,
		handleGap: 4,
	},
	full: {
		containerHeight: 44,
		trackHeight: 16,
		handleWidth: 4,
		handleHeight: 44,
		handleGap: 5,
	},
};

export const clamp = (value: number, min: number, max: number) =>
	Math.min(max, Math.max(min, value));

export const activeSegmentWidth = (dragX: number, gap: number) => {
	"worklet";
	return Math.max(0, dragX - gap);
};

export const inactiveSegmentWidth = (
	dragX: number,
	trackWidth: number,
	gap: number,
) => {
	"worklet";
	return Math.max(0, trackWidth - dragX - gap);
};

export const seekBarStyles = StyleSheet.create({
	container: {
		width: "100%",
		justifyContent: "center",
	},
	activeSegment: {
		position: "absolute",
		left: 0,
	},
	inactiveSegment: {
		position: "absolute",
		right: 0,
	},
	handle: {
		position: "absolute",
	},
});
